import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderPaymentSetting = createAsyncThunk("provdier/get-payment-setting", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-payment-setting`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

export const getClientAppointmentNotes = createAsyncThunk("provider/get-appointment-notes", async ({ appointmentId, paymentId }, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-appointment-notes/${paymentId}`,{
            // headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.documenttype);
    return res.data.providerAppointment;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});

export const getClientAppointmentNotesPayment = createAsyncThunk("provider/get-appointment-notes-payment", async (id, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-appointment-notes/${id}`,{
            // headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.documenttype);
    return res.data.providerAppointment;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});

export const updateProviderPaymentSetting = createAsyncThunk("provdier/update-payment-setting", async ({token, formData}, thunkAPI) => {
  try {
    const res = await axios.post(
        `${BACKEND_URL}/provider/update-payment-setting`,
        formData, 
        {
            headers: { 
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

export const getProviderPaymentList = createAsyncThunk("provdier/get-payment-list", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-payment-list`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

export const getClientProviderPaymentList = createAsyncThunk("provdier/get-client-payment-list", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-client-payment-list`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch clients payment");
  }
});

export const getProviderAllTranfer = createAsyncThunk("provider/get-all-tranfer", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-all-tranfer`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

export const retrieveProviderBalance = createAsyncThunk("provider/retrieve-balance", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/retrieve-balance`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

export const providerPayout = createAsyncThunk("provider/provider-payout", async ({token, amount,currency}, { rejectWithValue }) => {
  try {
      const formData = new FormData();
      formData.append("amount", amount);
      formData.append("currency", currency);
    const res = await axios.post(
        `${BACKEND_URL}/provider/provider-payout`,
        formData, 
        {
            headers: { Authorization: `Bearer ${token}` },
        });
    return res.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Failed to fetch providers payment");
  }
});

const providerPaymentSettingSlice = createSlice({
  name: "providerPaymentSetting",
    initialState: {
      providerPaymentSetting: null,
      providerList: [],
      clientList: [],
      providerPayment: [],
      retrieveBalance : null,
      clientAppointmentNotes: null,
      clientAppointmentNotesPayment: null,
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderPaymentSetting.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderPaymentSetting.fulfilled, (state, action) => {
            state.providerPaymentSetting = action.payload.paymentSetting;
            state.loading = false;
        })
        .addCase(getProviderPaymentSetting.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers payment"; 
            state.loading = false;
        })
        .addCase(updateProviderPaymentSetting.pending, (state) => {
            state.loading = true;
        })
        .addCase(updateProviderPaymentSetting.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload.message || "Provider PaymentSetting";
        })
        .addCase(updateProviderPaymentSetting.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Update failed";
        })
        .addCase(getProviderPaymentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderPaymentList.fulfilled, (state, action) => {
            state.providerList = action.payload.providerPayment;
            state.loading = false;
        })
        .addCase(getProviderPaymentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers payment"; 
            state.loading = false;
        })
        .addCase(getClientProviderPaymentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientProviderPaymentList.fulfilled, (state, action) => {
            state.clientList = action.payload.clientPayment;
            state.loading = false;
        })
        .addCase(getClientProviderPaymentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch clients payment"; 
            state.loading = false;
        })
        .addCase(getClientAppointmentNotes.pending, (state) => {
          state.loading = true;
        })
        .addCase(getClientAppointmentNotes.fulfilled, (state, action) => {
          state.clientAppointmentNotes = action.payload;
          state.loading = false;
        })
        .addCase(getClientAppointmentNotes.rejected, (state, action) => {
          state.error = action.payload || "Failed to fetch client appointment notes"; 
          state.loading = false;
        })
        .addCase(getClientAppointmentNotesPayment.pending, (state) => {
          state.loading = true;
        })
        .addCase(getClientAppointmentNotesPayment.fulfilled, (state, action) => {
          state.clientAppointmentNotesPayment = action.payload;
          state.loading = false;
        })
        .addCase(getClientAppointmentNotesPayment.rejected, (state, action) => {
          state.error = action.payload || "Failed to fetch client appointment notes"; 
          state.loading = false;
        })
        .addCase(getProviderAllTranfer.pending, (state) => {
          state.loading = true;
        })
        .addCase(getProviderAllTranfer.fulfilled, (state, action) => {
            state.providerPayment = action.payload.transfers;
            state.loading = false;
        })
        .addCase(getProviderAllTranfer.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch provider transfer"; 
            state.loading = false;
        })
        .addCase(retrieveProviderBalance.pending, (state) => {
          state.loading = true;
        })
        .addCase(retrieveProviderBalance.fulfilled, (state, action) => {
            state.retrieveBalance = action.payload.balance;
            state.loading = false;
        })
        .addCase(retrieveProviderBalance.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch provider balance"; 
            state.loading = false;
        })
        .addCase(providerPayout.pending, (state) => {
          state.loading = true;
        })
        .addCase(providerPayout.fulfilled, (state, action) => {
          state.loading = false;
          state.message = action.payload.message;
        })
        .addCase(providerPayout.rejected, (state, action) => {
            state.error = action.payload || "Failed to provider payout"; 
            state.loading = false;
        })
    },
});

export default providerPaymentSettingSlice.reducer;